import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFuelVendors = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/fuel-vendors/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendors fetch error:", error);
    throw error;
  }
};

const getFuelVendorFuelTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/fuel-vendors/fuel-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel vendor fuel types fetch error:", error);
    throw error;
  }
};

export { getFuelVendors, getFuelVendorFuelTypes };
